
import {Observable, throwError} from 'rxjs';
import {Injectable} from '@angular/core';
import {Session} from './Session';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import {TaxplanIQServices} from "./TaxplanIQServices";
import {PATH, SOURCE_TYPE} from "../constants/Tpiq.constants";

export function getdeleteChecklistUrl(org, userId, taskId, checklistId) {
    return `/TaxPlanningServices/org/${org}/users/${userId}/task/${taskId}/checklist/${checklistId}`;
}

export function getSaveChecklistUrl(orgId, userId, taskId) {
    return `/TaxPlanningServices/org/${orgId}/users/${userId}/task/${taskId}/checklist`;
}

export function getAddNewChecklistUrl(orgId, userId) {
    return `/TaxPlanningServices/org/${orgId}/users/${userId}/checklist`;
}

@Injectable({
  providedIn: 'root'
})
export class CheckListsService extends  TaxplanIQServices {

    options = {};
    constructor(http: HttpClient) {
        super(http);
    }

    getChecklists(org, taskId, companyId): Observable<any> {
        const url = this.interpolateUrl(PATH.CHECKLISTS_SERVICE, null, {userId: Session.getUser().id, taskId});
        return this.query(url + '?org=' + org + '&companyId=' + companyId, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
    }

    addChecklists(org, id, data): Observable<any> {
        const url = getSaveChecklistUrl(org, Session.getUser().id, id);
        return this.update(url, data, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));

    }

    addNewChecklists(org, data): Observable<any> {
      const url = getAddNewChecklistUrl(org, Session.getUser().id);
      return this.create(url, data, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
    }

    deleteChecklist(userId, taskId, checklistId, checklist, isDeleted): Observable<any>  {
        let url = getdeleteChecklistUrl(Session.getOrg(), userId, taskId, checklistId);
        url = url + '?isDeleted=' + isDeleted;
        return this.update(url, checklist, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
    }

    private handleError(error: HttpErrorResponse) {
        return throwError(error.error);
    }
}

